import { Skeleton } from "antd";
import VoucherBankDrawer from "./voucher/drawer";

const DrawerContent = ({ fundName, loading, inquiryAmount, onFundClick }) => {
  function getMoneyScale(amount, type = "ریال") {
    if ([null, undefined].includes(amount)) return ["", ""];

    const separateAmount = `${amount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const sliceAmount = separateAmount.split(",")[0];

    if (amount >= 1_000_000_000) {
      return [
        separateAmount + ` میلیارد ${type}`,
        sliceAmount + +` میلیارد ${type}`,
      ];
    } else if (amount >= 1_000_000) {
      return [
        separateAmount + ` میلیون ${type}`,
        sliceAmount + ` میلیون ${type}`,
      ];
    } else if (amount >= 1_000) {
      return [separateAmount + ` هزار ${type}`, sliceAmount + ` هزار ${type}`];
    } else {
      return [separateAmount + ` ${type}`, sliceAmount + ` ${type}`];
    }
  }

  return (
    <>
      <img
        className="w-[160px] h-[157px] mx-auto"
        src={"https://cdn.firouzeh.com/public/bank-limit-amount.png"}
        alt="limit-amount"
      />
      {loading ? (
        <Skeleton active />
      ) : (
        <div className="flex flex-col gap-4">
          <div className=" p-4 rounded-lg border border-gray--6 text-gray-4 mt-8 flex flex-col">
            <span className="body-16px-demibold ">
              <span className="text-primary-1">
                {getMoneyScale(inquiryAmount?.asset_amount)[0]}
              </span>{" "}
              سرمایه در {fundName}
            </span>
            <p className="body-14px-regular my-4">
              از طریق فیروزه کارت، سرمایه شما در صندوق {fundName} در هر‌لحظه در
              دسترس خواهد بود. برای دریافت کارت باید
              <span className="body-14px-demibold">
                {" "}
                حداقل {getMoneyScale(inquiryAmount?.min_amount)[1]}{" "}
              </span>
              در صندوق {fundName}، سرمایه‌ داشته باشید.
            </p>

            <span
              onClick={() => onFundClick()}
              className="text-blue-0 self-end caption-12px-medium"
            >
              مشاهده صندوق {fundName}
            </span>
          </div>
          <VoucherBankDrawer />
        </div>
      )}
    </>
  );
};
export default DrawerContent;
